import BottomBar from "../Components/BottomBar";
import FloatingWhats from "../Components/FloatingWhats";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import React, { useState } from "react";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button } from "@mui/material";
import styles from "../styles/ProdCAD.css"


const images = [
    "/images/cad1.png",
    "/images/cad2.png",
];

const ProdCAD = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    
    const nextImage = () => {
        setCurrentIndex((prev) =>
            prev === images.length - 1 ? 0 : prev + 1
        );
    };

    const prevImage = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? images.length - 1 : prev - 1
        );
    };
    
    return(
        <div className="container">
            <FloatingWhats/>
            <Header/>    
            <div className="content">
                <div className="bannerInterno-container from-top">
                    <div className="bannerInterno-content">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">CAD<br/>Conversor Analógico Digital</h1>
                            <img className="bannerInterno-img" src="/images/banner-cad.png" alt="Banner CAD"/>
                        </div>
                    </div>
                </div>
                <div className="caminho">
                    <div className="caminho-content from-left">
                        <a className="caminho-link" href="/">Início</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos">Produtos</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos/pesagem-rodoviaria">Pesagem Rodoviária</a>
                        <span className="caminho-separador">/</span>
                        <span className="caminho-atual">CAD</span>
                    </div>
                </div>
                <div className="produto-header">
                    <div className="produto-header-content">
                        <div className="produto-header-left from-left">
                            <div className="produto-header-fotosBox">
                                <img className="produto-header-foto" src={images[currentIndex]} alt="Produto" />
                                <button className="produto-header-btn left" onClick={prevImage}><ChevronLeftIcon sx={{ fontSize: 40 }}/></button>
                                <button className="produto-header-btn right" onClick={nextImage}><ChevronRightIcon sx={{ fontSize: 40 }} /></button>
                            </div>
                        </div>
                        <div className="produto-header-right from-right">
                            <div className="produto-header-infoBox">
                                <div className="produto-header-infoBox1">
                                    <h1 className="produto-header-name from-right">CAD Conversor Analógico Digital</h1>
                                </div>
                                <div className="produto-header-descricao">
                                    <span className="produto-header-info"><strong>Fabricante:</strong> Weightech</span>
                                    <span className="produto-header-info"><strong>Tipo de Sinal:</strong> Conversão de analógico para digital</span>
                                    <span className="produto-header-info"><strong>Classe de Proteção:</strong> IP69K</span>
                                    <span className="produto-header-info"><strong>Material:</strong> Aço Inoxidável</span>
                                    
                                </div>
                                <div className="produto-header-infoBox3">
                                    <h3 className="produto-header-chamada">
                                        <span style={{color:'#474747'}}>Alguma Dúvida?</span>
                                    </h3>
                                    <a href="https://wa.me/+556599547518"><Button sx={{fontFamily:'Inter', textTransform:'none', width:'100%', height:90, backgroundColor:'#474747', borderRadius:'8px', color:'#fff', fontSize:'20px','&:hover':{backgroundColor:'#7D1115'}}}>Falar com Vendedor</Button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="downloads from-left">
                    <div className="downloads-content">
                        <h3 className="downloads-title">Arquivos para Download</h3>
                        <div className="downloads-links">
                            <a className="downloads-link" href="https://drive.google.com/drive/folders/12ZrX5NxSo42e2EI4zU6Hx_E_5V9dFizK?usp=sharing" target="_blank" rel="noopener noreferrer"><img src="/images/icons/arquivo.svg" className="download-icon"/>Instalador BC-Net</a>
                            <a className="downloads-link" href="https://drive.google.com/drive/folders/1pLdBJUGhlztSiSragyblwqDkjxFhx4Ur?usp=sharing" target="_blank" rel="noopener noreferrer"><img src="/images/icons/arquivo.svg" className="download-icon"/>Instalador BC-Rodo</a>
                            <a className="downloads-link" href="https://drive.google.com/drive/folders/1ZjgGttDaCA9lKfrkBCgVW_oYXSn7VFPO?usp=sharing" target="_blank" rel="noopener noreferrer"><img src="/images/icons/arquivo.svg" className="download-icon"/>Hercules</a>
                        </div>
                    </div>
                </div>
                <div className="cad-descricao">
                    <div className="cad-descricao-content from-bottom">
                        <h2 className="cad-descricao-title">Descrição</h2>
                        <div className="cad-descricao-text">
                            <h3>O BC-CAD é um indicador de pesagem virtual, que possui portaria aprovada no INMETRO.</h3>
                            <ul>
                                <li>Mais funções do que um equipamento físico convencional;</li>  
                                <li>Mais eficiência, menor custo, menos tempo de manutenção;</li>
                            </ul>
                            <h3>Com a aquisição do BC-CAD, uma licença exclusiva para o uso do Software de Gerenciamento de Pesagens é fornecido gratuitamente, tornando seu custo ainda mais competitivo, frente a outras soluções oferecidas no mercado.</h3>
                            <h3>O BC-CAD permite a integração de células de carga digitais e analógicas, com suporte para monitoramento e ajustes por meio de IoT e conexão à internet.</h3>
                        </div>
                    </div>
                </div>
                <div className="cad-beneficios">
                    <div className="cad-beneficios-content">
                        <div className="cad-beneficios-brick from-bottom" style={{ transitionDelay: '0.1s' }}>
                            <img src="/images/icons/celula.svg"/>
                            <h4 className="cad-beneficios-title">Flexibilidade na calibração</h4>
                        </div>
                        <div className="cad-beneficios-brick from-bottom" style={{ transitionDelay: '0.2s' }}>
                            <img src="/images/icons/pc.svg"/>
                            <h4 className="cad-beneficios-title">Controle em tempo real</h4>
                        </div>
                        <div className="cad-beneficios-brick from-bottom" style={{ transitionDelay: '0.3s' }}>
                            <img src="/images/icons/binoculo.svg"/>
                            <h4 className="cad-beneficios-title">Monitoramento remoto</h4>
                        </div>
                    </div>
                </div>
                <div className="requisitos">
                    <div className="requisitos-content">
                        <h2 className="cad-descricao-title from-bottom">Pré-Requisitos</h2>
                        <div className="home2-topics from-left">
                            <div className="home2-middle">
                                <div className="home2-middle-icon">
                                    <img src='/images/icons/req1.svg'/>
                                </div>
                                <div className="home2-middle-text">
                                    <span className='home2-middle-title'><strong>Conexão à internet:</strong> Rede estável e confiável para transmissão de dados.</span>
                                </div>
                            </div>
                            <div className="home2-bar"/>
                            <div className="home2-middle">
                                <div className="home2-middle-icon">
                                    <img src='/images/icons/req2.svg'/>
                                </div>
                                <div className="home2-middle-text">
                                    <span className='home2-middle-title'><strong>Células Digitais ou Caixa de Junção BC-CAD:</strong> Permite a conversão de sinais analógicos para digitais.</span>
                                </div>
                            </div>
                            <div className="home2-bar"/>
                            <div className="home2-middle">
                                <div className="home2-middle-icon">
                                    <img src='/images/icons/req3.svg'/>
                                </div>
                                <div className="home2-middle-text">
                                    <span className='home2-middle-title'><strong>Software de Gerenciamento BC-CAD:</strong> Monitora e ajusta remotamente os parâmetros da balança.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="monitoramento">
                    <div className="monitoramento-content">
                        <h3 className="horario-atendimento-title from-bottom" style={{textAlign:'center', marginBottom:'40px'}}>
                            <span style={{color:'#474747'}}>Diagnóstico e </span>
                            <span style={{color:'#9E1518'}}>Monitoramento</span>
                        </h3>
                        <h4 className="monitoramento-text from-bottom">O <strong>BC-CAD</strong> possui funções de <strong>controle e notificações</strong> de desgaste, falhas e sobrecargas
                        que permitem que nossa assistência técnica se <strong>antecipe o chamado</strong> para atendimento
                        de falhas significativas no sistema (como células danificadas) ou mesmo <strong>manutenção preventica</strong> (como a troca de células desgastadas).</h4>
                        <div className="monitoramento-divisor">
                            <div className="monitoramento-left from-left">
                                <h3>Os controles e notificações disponíveis são:</h3>
                                <ul>
                                    <li>Controle de vida útil das células de carga atravéz da análise de deriva do zero e deriva instantânea para detecção (Ex: Freadas Bruscas).</li><br/>
                                    <li>Histórico de intervenções, configurações, calibrações, falhas e ventuais sobrecargas.</li><br/>
                                    <li>Notificações via email com print-screen de alterações nas configurações do indicador e de todas as etapas de calibração (zero, span e cantos).</li><br/>
                                    <li>Notificações de sobrecarga geral, seção e célula com tabela dos counts de cada célula no momento do evento e notificação de vida útil de cada célula com base em percentual de deriva de zero definido na instalação da balança, permitindo uma análise a respeito da necessidade de manutenção ou a respeito do uso adequado da balança.</li><br/>
                                    <li>Salva arquivos de backup de calibração.</li><br/>
                                    <li>Ao final da calibração, envia um email contendo o backup da configuração e calibração da SealingBox, assim, caso necessário é possível recuperar a configuração e o estado de calibração do sistema.</li>
                                </ul>
                                <h4>Além disso, elas permitem um maior controle a respeito das intervenções na balança pois envia notificações sempre que houverem alterações na configuração do sistema.</h4>
                            </div>
                            <div className="monitoramento-right from-right">
                                <img className='monitoramento-left-img' src='/images/balCad.png'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="etapas">
                    <div className="etapas-content">
                        <h3 className="horario-atendimento-title from-bottom" style={{textAlign:'center', marginBottom:'40px'}}>
                            <span style={{color:'#474747'}}>Etapas para </span>
                            <span style={{color:'#9E1518'}}>Ajuste Remoto</span>
                        </h3>
                        <div className="etapas-bricks">
                            <div className="etapas-line from-left"/>
                            <div className="etapas-brick from-bottom" style={{ transitionDelay: '0.1s' }}>
                                <img src="/images/icons/passo1.svg"/>
                                <h4 className="etapas-title">Acesso a dados das células de carga.</h4>
                                <h4 className="etapas-title">Indentificar erros como desvio de zero e diferença entre células.</h4>
                            </div>
                            <div className="etapas-brick from-bottom" style={{ transitionDelay: '0.2s' }}>
                                <img src="/images/icons/passo2.svg"/>
                                <h4 className="etapas-title">Redefinição de zero da balança.</h4>
                                <h4 className="etapas-title">Ajustes na sensibilidade dos sensores</h4>
                            </div>
                            <div className="etapas-brick from-bottom" style={{ transitionDelay: '0.3s' }}>
                                <img src="/images/icons/passo3.svg"/>
                                <h4 className="etapas-title">Verificação de precisão das leituras em tempo real.</h4>
                            </div>
                        </div>
                    </div>
                </div>





                <BottomBar/>
                <Footer/>
            </div>
        </div>
    )
}
export default ProdCAD;